import { makeStyles } from '@material-ui/styles'
import { pageContentHorizontalGutters } from 'lib/styles/page-content-gutters'

export const useStyles = makeStyles(theme => ({
  coachProfileCardsContainer: {
    margin: '2rem auto 6rem',
    maxWidth: 832,
    padding: '0 1rem',
  },
  coachProfileContent: pageContentHorizontalGutters(theme, {
    paddingTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    width: 'auto',
    sm: {
      paddingTop: theme.spacing(2),
      marginTop: 10,
      marginBottom: theme.spacing(4),
    },
  }),
  emptyStateContent: {
    padding: theme.spacing(4, 2),
  },
  launchIcon: {
    fontSize: '0.8rem',
    margin: '10px 0 10px 5px',
  },
  analyticsCardContainer: {
    padding: '2rem',
  },
}))
